import { useQuery } from "@apollo/client"
import { VotedChallengeDocument } from "@artists/gql/design-challenges"
import { useTypedParams } from "react-router-typesafe-routes/dom"

import { Root } from "../../../../utils"

export const useChallengeQuery = () => {
	const { slug } = useTypedParams(Root.Vote)

	return useQuery(VotedChallengeDocument, { variables: { slug } })
}
